import AOS from "aos";
import lozad from "lozad";
import { setBackgroundElement, detectCloseElement, buttonToTop, clickScrollToDiv, appendCaptchaASP, replaceSvgImages, funcExpandContent } from "./helper";
import { header } from "./header";
import { swiperInit } from "./swiper";
import { animation } from "./animation";
import { setCookie, getCookie } from "./helper";
import noUiSlider from 'nouislider';
import { form } from "./form";
import { Fancybox } from "@fancyapps/ui";
import Toastify from 'toastify-js'


$(document).ready(function () {
	setBackgroundElement();
	header.init();
	form.init();
	swiperInit();
	animation.init();
	replaceSvgImages();
	handleSidebar();
	toggleSidebar();
	// initSidebarState(); // Initialize sidebar state from cookie
	initSliderMagazine();
	buttonToTop();
	initPasswordToggle(); // Initialize password toggle functionality
	initCustomCheckbox(); // Initialize custom checkbox functionality
	funcExpandContent({
		parent: '.wrap-box-comment-list',
		children: '.list-comment-news',
		item: '.item-comment-news',
		button: '.btn-expand-comment',
		initItem: 2,
		expandItem: 3,
	});
	initFancybox();
	initMultiStepModal();
	window.Fancybox = Fancybox;
	openPopupHomePage();
	handleItemVideoPlay();
	handleAds();
});

function handleAds () {
	$('.btn.ads .btn-icon').on('click', function (e) {
		e.preventDefault();
		$(this).closest('.btn.ads').toggleClass('active');
	});
}
function handleItemVideoPlay () {
	$(document).on('click', '.item-video-play', function (e) {
		e.preventDefault();

		const $item = $(this);
		const href = $item.find('a.img').attr('href');
		const title = $item.find('.title > a').text().trim();
		const authorName = $item.find('.author-name span').first().text().trim();
		const authorAvatar = $item.find('.author-avatar img').attr('src');

		// Extract video ID from YouTube URL
		const videoId = extractYouTubeVideoId(href);

		if (videoId) {
			// Create embed URL
			const embedUrl = `https://www.youtube.com/embed/${videoId}?mute=0&autoplay=1`;

			const $boxVideo = $('.tool-video-fixed .box-video');
			let $iframe = $boxVideo.find('iframe');

			// Create iframe if it doesn't exist
			if ($iframe.length === 0) {
				$iframe = $('<iframe>', {
					frameborder: '0',
					allowfullscreen: true,
					allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
					referrerpolicy: 'strict-origin-when-cross-origin',
					width: '500',
					height: '250'
				});
				$boxVideo.prepend($iframe);
			}

			// Update iframe
			$iframe.attr('src', embedUrl);
			$iframe.attr('title', title);

			// Update content
			$('.tool-video-fixed .box-content .title').text(title);
			$('.tool-video-fixed .box-content .author-content').text(authorName);

			// Update author avatar if exists
			if (authorAvatar) {
				$('.tool-video-fixed .box-content .author-avatar img').attr('src', authorAvatar);
			}

			// Show the video player if hidden
			$('.tool-video-fixed').addClass('active');
		}
	});

	// Handle close video player
	$(document).on('click', '.btn-close-video', function (e) {
		e.preventDefault();
		$('.tool-video-fixed').removeClass('active');
		// Stop video by removing src and adding it back
		const $iframe = $('.tool-video-fixed .box-video iframe');
		if ($iframe.length > 0) {
			const src = $iframe.attr('src');
			$iframe.attr('src', '');
			setTimeout(() => {
				$iframe.attr('src', src.replace('autoplay=1', 'autoplay=0'));
			}, 100);
		}
	});
}

function extractYouTubeVideoId (url) {
	if (!url) return null;

	// Handle different YouTube URL formats
	const regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
	const match = url.match(regex);

	return match ? match[1] : null;
}

function openPopupHomePage () {
	setTimeout(() => {
		// openFancybox('#popup-home-page');
	}, 1000);
}
/*==================== Multi-Step Modal ====================*/
function initMultiStepModal () {
	// Store modal instances
	const modalInstances = {};

	// Initialize modal when opened
	// $(document).on('beforeShow.fb', function (e, instance, slide) {
	// 	const modalId = slide.src;
	// 	console.log("🚀 ~ modalId:", modalId)
	// 	if (modalId && modalId.startsWith('#') && $(modalId).find('.form-content').length > 0) {
	// 	}
	// });
	initModalInstance('#modal-login');

	function initModalInstance (modalId) {
		// Get all steps in this modal
		const steps = $(modalId).find('.form-content');
		const totalSteps = steps.length;

		if (totalSteps === 0) return;

		// Create modal instance
		modalInstances[modalId] = {
			currentStep: 1,
			totalSteps: totalSteps,
			steps: steps,
			modalId: modalId
		};

		// Reset to first step
		resetModal(modalId);
	}

	function resetModal (modalId) {
		const instance = modalInstances[modalId];
		if (!instance) return;

		// Hide all steps
		instance.steps.hide();
		// Show first step
		instance.steps.first().show();
		instance.currentStep = 1;
	}

	function goToNextStep (modalId) {
		const instance = modalInstances[modalId];
		if (!instance || instance.currentStep >= instance.totalSteps) return;

		// Hide current step
		$(instance.steps[instance.currentStep - 1]).fadeOut(300, function () {
			instance.currentStep++;
			// Show next step
			$(instance.steps[instance.currentStep - 1]).fadeIn(300);
		});
	}

	function goToPrevStep (modalId) {
		const instance = modalInstances[modalId];
		if (!instance || instance.currentStep <= 1) return;

		// Hide current step
		$(instance.steps[instance.currentStep - 1]).fadeOut(300, function () {
			instance.currentStep--;
			// Show previous step
			$(instance.steps[instance.currentStep - 1]).fadeIn(300);
		});
	}

	function goToStep (modalId, stepNumber) {
		const instance = modalInstances[modalId];
		if (!instance || stepNumber < 1 || stepNumber > instance.totalSteps) return;

		// Hide current step
		$(instance.steps[instance.currentStep - 1]).fadeOut(300, function () {
			instance.currentStep = stepNumber;
			// Show target step
			$(instance.steps[instance.currentStep - 1]).fadeIn(300);
		});
	}

	function skipToFinal (modalId) {
		const instance = modalInstances[modalId];
		if (!instance) return;

		goToStep(modalId, instance.totalSteps);
	}

	function closeModal (modalId) {
		Fancybox.close();
		// Reset to first step when modal is closed
		setTimeout(() => resetModal(modalId), 300);
	}

	// Event handlers
	$(document).on('click', '.btn-next', function (e) {
		e.preventDefault();
		const modalId = $(this).closest('.modal-popup-general').attr('id');
		if (modalId) {
			goToNextStep('#' + modalId);
		}
	});

	$(document).on('click', '.btn-prev', function (e) {
		e.preventDefault();
		const modalId = $(this).closest('.modal-popup-general').attr('id');
		if (modalId) {
			goToPrevStep('#' + modalId);
		}
	});

	$(document).on('click', '.btn-skip', function (e) {
		e.preventDefault();
		const modalId = $(this).closest('.modal-popup-general').attr('id');
		if (modalId) {
			skipToFinal('#' + modalId);
		}
	});

	$(document).on('click', '.btn-close-modal', function (e) {
		e.preventDefault();
		const modalId = $(this).closest('.modal-popup-general').attr('id');
		if (modalId) {
			closeModal('#' + modalId);
		}
	});

	$(document).on('click', '.btn-finish', function (e) {
		e.preventDefault();
		const modalId = $(this).closest('.modal-popup-general').attr('id');
		if (modalId) {
			closeModal('#' + modalId);
		}
	});

	// Custom step navigation with data attributes
	$(document).on('click', '[data-step-to]', function (e) {
		e.preventDefault();
		const stepNumber = parseInt($(this).attr('data-step-to'));
		const modalId = $(this).closest('.modal-popup-general').attr('id');
		if (modalId && stepNumber) {
			goToStep('#' + modalId, stepNumber);
		}
	});

	// Expose functions globally for external use
	window.multiStepModal = {
		goToNextStep: goToNextStep,
		goToPrevStep: goToPrevStep,
		goToStep: goToStep,
		skipToFinal: skipToFinal,
		closeModal: closeModal,
		resetModal: resetModal
	};
}
function initSliderMagazine () {
	const windowSlide = window.swiperMagazine;
	if (!windowSlide) return;

	// Get pagination bullets count instead of slide length
	const paginationBullets = windowSlide.pagination.bullets;
	const bulletCount = paginationBullets ? paginationBullets.length : 0;

	if (bulletCount === 0) return;

	// Use bullet count - 1 for max range (0-based indexing)
	const maxRange = bulletCount - 1;

	// Flag to prevent circular triggers
	let isUpdatingFromSlider = false;

	// Handle Slider Pagination
	const sliderPaginationRange = document.getElementById('slider-pagination-range');
	const sliderMagazine = noUiSlider.create(sliderPaginationRange, {
		start: 0,
		connect: [true, false],
		behaviour: "smooth-steps",
		step: 1,
		range: {
			min: 0,
			max: maxRange,
		},
		format: {
			to: function (value) {
				return Math.round(value);
			},
			from: function (value) {
				return Number(value);
			},
		},
		pips: {
			mode: "steps",
			density: 100,
			values: maxRange,
			format: {
				to: function (value) {
					return Math.round(value);
				},
			},
		},
	});

	sliderMagazine.on("update", function (values) {
		const slideIndex = parseInt(values[0], 10);
		// Only trigger slideTo if the current slide is different and not updating from swiper

		if (windowSlide.activeIndex !== slideIndex && !isUpdatingFromSlider) {
			isUpdatingFromSlider = true;
			windowSlide.slideTo(slideIndex);
			// Reset flag after slide transition
			setTimeout(() => {
				isUpdatingFromSlider = false;
			}, 100);
		}
	});

	windowSlide.on("slideChange", function () {
		// Get active pagination bullet index instead of slide index
		const activeBulletIndex = windowSlide.pagination.bullets ?
			Array.from(windowSlide.pagination.bullets).findIndex(bullet =>
				bullet.classList.contains('swiper-pagination-bullet-active')
			) : windowSlide.realIndex || 0;
		console.log("🚀 ~ activeBulletIndex:", activeBulletIndex)
		// Only update noUiSlider if not currently updating from slider
		if (!isUpdatingFromSlider) {
			const currentSliderValue = parseInt(sliderMagazine.get(), 10);
			if (currentSliderValue !== activeBulletIndex) {
				sliderMagazine.set(activeBulletIndex);
			}
		}
	});
}

/*==================== Handle Sidebar ====================*/
function handleSidebar () {
	const nodeTitleClick = ['.menu-list-title', 'li.has-children>a']
	nodeTitleClick.forEach(item => {
		$(item).on('click', function (e) {
			e.preventDefault();
			$(this).toggleClass('active');
			$(this).next().slideToggle();
		});
	});
}

function initSidebarState () {
	const sidebarState = getCookie('sidebarState');
	const btnSidebarToggle = $('.btn-sidebar-toggle');
	const dataTextOpen = {
		open: btnSidebarToggle.find('.tooltip').attr('data-tooltip-open'),
		close: btnSidebarToggle.find('.tooltip').attr('data-tooltip-close')
	}

	if (sidebarState === 'hidden') {
		$('body').addClass('is-sidebar-hidden');
		btnSidebarToggle.find('span').text(dataTextOpen.open);
	} else {
		$('body').removeClass('is-sidebar-hidden');
		btnSidebarToggle.find('span').text(dataTextOpen.close);
	}
}

function toggleSidebar () {
	const btnSidebarToggle = $('.btn-sidebar-toggle');
	const dataTextOpen = {
		open: btnSidebarToggle.find('.tooltip').attr('data-tooltip-open'),
		close: btnSidebarToggle.find('.tooltip').attr('data-tooltip-close')
	}
	btnSidebarToggle.on('click', function (e) {
		e.preventDefault();
		$('body').toggleClass('is-sidebar-hidden');

		if ($('body').hasClass('is-sidebar-hidden')) {
			btnSidebarToggle.find('span').text(dataTextOpen.open);
			setCookie('sidebarState', 'hidden');
		} else {
			btnSidebarToggle.find('span').text(dataTextOpen.close);
			setCookie('sidebarState', 'visible');
		}
	});
}

/*==================== Password Toggle ====================*/
function initPasswordToggle () {
	$('.form-password input').on('click', function (e) {
		// Check if click is in the right area where the icon would be
		const input = $(this);
		const inputOffset = input.offset();
		const inputWidth = input.outerWidth();
		const clickX = e.pageX - inputOffset.left;

		// If click is in the rightmost 50px area (where icon is)
		if (clickX > inputWidth - 50) {
			const passwordInput = $(this);
			const formGroup = $(this).closest('.form-password');

			if (passwordInput.attr('type') === 'password') {
				passwordInput.attr('type', 'text');
				formGroup.addClass('show-password');
			} else {
				passwordInput.attr('type', 'password');
				formGroup.removeClass('show-password');
			}
		}
	});
}
/*==================== Fancybox ====================*/
function initFancybox () {
	// Global configuration for all Fancybox instances
	Fancybox.bind('[data-fancybox]', {
		mainClass: 'fancybox-global-class',
		hideScrollbar: false,
		animated: true,
		showClass: "f-fadeIn",
		hideClass: "f-fadeOut",
		backdrop: {
			styles: {
				"--fancybox-bg": "rgba(24,24,27,.5)"
			}
		}
	});
}
function openFancybox (src) {
	if (!$(src).length) return;
	Fancybox.show([{ src: src, class: 'fancybox-global-class' }]);
}
window.openFancybox = openFancybox;

/*==================== Custom Checkbox ====================*/
function initCustomCheckbox () {
	// No additional JavaScript needed - CSS handles the visual state changes
	// The checkbox functionality is handled by CSS pseudo-elements
}

/*==================== Aos Init ====================*/
AOS.init({
	offset: 100,
});

/*==================== Lazyload JS ====================*/
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();


window.FE = {
	lozad: observer.observe,
	toast: {
		success: (message, options = {}) => {
			console.log(message)
			Toastify({
				text: `<i class="fas fa-check-circle"></i> ${message}`,
				duration: options.duration || 2000000,
				close: true,
				gravity: options.gravity || "top",
				position: options.position || "right",
				escapeMarkup: false,
				className: "toast-success",
				style: {
					background: "#34C759", // Apple Green
					color: "#FFFFFF",
					borderRadius: "12px",
					fontSize: "14px",
					fontWeight: "500",
					padding: "16px 20px",
					boxShadow: "0 4px 16px rgba(52, 199, 89, 0.25)"
				},
			}).showToast();
		},
		error: (message, options = {}) => {
			Toastify({
				text: `<i class="fas fa-exclamation-circle"></i> ${message}`,
				duration: options.duration || 5000,
				close: true,
				gravity: options.gravity || "top",
				position: options.position || "right",
				escapeMarkup: false,
				className: "toast-error",
				style: {
					background: "#FF3B30", // Apple Red
					color: "#FFFFFF",
					borderRadius: "12px",
					fontSize: "14px",
					fontWeight: "500",
					padding: "16px 20px",
					boxShadow: "0 4px 16px rgba(255, 59, 48, 0.25)"
				},
			}).showToast();
		},
		warning: (message, options = {}) => {
			Toastify({
				text: `<i class="fas fa-exclamation-triangle"></i> ${message}`,
				duration: options.duration || 4000,
				close: true,
				gravity: options.gravity || "top",
				position: options.position || "right",
				escapeMarkup: false,
				className: "toast-warning",
				style: {
					background: "#FF9500", // Apple Orange
					color: "#FFFFFF",
					borderRadius: "12px",
					fontSize: "14px",
					fontWeight: "500",
					padding: "16px 20px",
					boxShadow: "0 4px 16px rgba(255, 149, 0, 0.25)"
				},
			}).showToast();
		},
		info: (message, options = {}) => {
			Toastify({
				text: `<i class="fas fa-info-circle"></i> ${message}`,
				duration: options.duration || 4000,
				close: true,
				gravity: options.gravity || "top",
				position: options.position || "right",
				escapeMarkup: false,
				className: "toast-info",
				style: {
					background: "#007AFF", // Apple Blue
					color: "#FFFFFF",
					borderRadius: "12px",
					fontSize: "14px",
					fontWeight: "500",
					padding: "16px 20px",
					boxShadow: "0 4px 16px rgba(0, 122, 255, 0.25)"
				},
			}).showToast();
		},
		// Additional toast types
		loading: (message, options = {}) => {
			return Toastify({
				text: `<i class="fas fa-spinner fa-spin"></i> ${message}`,
				duration: options.duration || -1, // -1 means it won't auto-close
				close: false,
				gravity: options.gravity || "top",
				position: options.position || "right",
				escapeMarkup: false,
				className: "toast-loading",
				style: {
					background: "#8E8E93", // Apple Gray
					color: "#FFFFFF",
					borderRadius: "12px",
					fontSize: "14px",
					fontWeight: "500",
					padding: "16px 20px",
					boxShadow: "0 4px 16px rgba(142, 142, 147, 0.25)"
				}
			}).showToast();
		},
	},
}